import React from 'react';
import {BrowserRouter, Switch, Route} from 'react-router-dom';
import {history} from '../Redux/Store';
import ProtectedRoute from './protectedRoutes';

import Login from '../Components/Auth/login';
import ForgotPassword from '../Components/Auth/forgotPassword';
import Dashboard from '../Components/Dashboard';
import JobsManagement from '../Components/Jobs';
import IndividualJob from '../Components/Jobs/info';
import StaffManagement from '../Components/Staff';
import AddStaff from '../Components/Staff/add';
import UpdateStaff from '../Components/Staff/update';
import Reports from '../Components/Reports';
import ChangePassword from '../Components/Auth/changePassword';
import Warning from '../Components/Ui/400';
import ErrorBoundary from '../Components/ErrorBoundary';
import Notifications  from '../Components/Notifications';
import AccessDeniedAlert from '../Components/Ui/403';

const Routes = () => (
    <BrowserRouter>
        <ErrorBoundary>
            <Switch history={history}>
                <Route exact path="/" component={Login} />
                <Route exact path="/forgot-password" component={ForgotPassword} />
                <ProtectedRoute exact path="/dashboard" loggedUser={true} component={Dashboard} />
                <ProtectedRoute exact path="/jobs" loggedUser={true} component={JobsManagement} />
                <ProtectedRoute exact path="/notifications" loggedUser={true} component={Notifications} />
                <ProtectedRoute exact path="/jobs/:jobID" loggedUser={true} component={IndividualJob} />
                <ProtectedRoute exact path="/staff" loggedUser={true} component={StaffManagement} />
                <ProtectedRoute exact path="/staff/add" loggedUser={true} component={AddStaff} />
                <ProtectedRoute exact path="/staff/update/:staffID" loggedUser={true} component={UpdateStaff} />
                <ProtectedRoute exact path="/reports" loggedUser={true} component={Reports} />
                <ProtectedRoute exact path="/change-password" loggedUser={true} component={ChangePassword} />
                <Route exact path="/access-denied" component={AccessDeniedAlert} />
                <Route component={Warning} />
            </Switch>
        </ErrorBoundary>
    </BrowserRouter>
);

export default Routes;